<template>
  <img v-if="fileType === 'image'" :src="`${imageUrl}/${fileId}.jpg`" loading="lazy" v-bind="$attrs" />
  <div v-if="fileType === 'video'" class="relative">
    <video :src="`${imageUrl}/${fileId}.mp4`" loading="lazy" :controls="showControls" type="video/mp4"
      preload="metadata" v-bind="$attrs" />
    <PlayCircleIcon v-if="showFakePlay" @click="$attrs.onClick"
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-16 w-16 text-white z-10 cursor-pointer" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { PlayCircleIcon } from '@heroicons/vue/24/solid'

import { imageUrl } from '@/utils/constants'

export interface MediaViewProps {
  fileId: string
  showControls?: boolean
  showFakePlay?: boolean
}

defineEmits<{
  (e: 'close'): void
}>()

const props = withDefaults(defineProps<MediaViewProps>(), {
  showControls: false,
  showFakePlay: false
})
const fileType = ref<'image' | 'video' | ''>('')

onMounted(async () => {
  await fetch(`${imageUrl}/${props.fileId}.mp4`, {
    method: 'HEAD',
  }).then((res) => {
    if (res.status === 404) {
      fileType.value = 'image'
    }
  }).catch((e) => {
    fileType.value = 'video'
  })
})
</script>
